export default __webpack_public_path__ + "static/media/img_matching_book.07eb892c.png";